export function levenshteinDistance(a: string, b: string): number {
  const matrix: number[][] = [];
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  return matrix[b.length][a.length];
}

export function stem(word: string): string {
  let w = word.toLowerCase();
  const suffixes = ['room', 'ing', 'tion', 'er', 'ed', 'ly', 's'];
  for (const suffix of suffixes) {
    if (w.length > suffix.length + 2 && w.endsWith(suffix)) {
      return w.slice(0, -suffix.length);
    }
  }
  return w;
}

export function getStemmedWords(text: string): string[] {
  return text.toLowerCase()
    .split(/[\s\-_]+/)
    .filter(w => w.length > 0)
    .map(stem);
}

export function hasWordOverlap(inputWords: string[], tradeWords: string[]): boolean {
  for (const iw of inputWords) {
    for (const tw of tradeWords) {
      if (iw === tw) return true;
      if (iw.length >= 3 && tw.length >= 3) {
        if (iw.includes(tw) || tw.includes(iw)) return true;
      }
    }
  }
  return false;
}

export function fuzzyMatchType(input: string, existingTypes: string[]): string | null {
  const normalized = input.trim().toLowerCase();
  if (!normalized) return null;

  const exact = existingTypes.find(t => t.toLowerCase() === normalized);
  if (exact) return exact;

  const startsWith = existingTypes.find(t => t.toLowerCase().startsWith(normalized));
  if (startsWith) return startsWith;

  const contains = existingTypes.find(t => t.toLowerCase().includes(normalized));
  if (contains) return contains;

  const inputWords = getStemmedWords(normalized);
  const stemmed = existingTypes.find(t => hasWordOverlap(inputWords, getStemmedWords(t)));
  if (stemmed) return stemmed;

  const closest = existingTypes.find(t => levenshteinDistance(t.toLowerCase(), normalized) <= 2);
  if (closest) return closest;

  return null;
}

export function toTitleCase(str: string): string {
  return str.trim().replace(/\w\S*/g, (word) =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );
}